import React from "react";
import { Box, Typography, Fade } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { useAiLoadingMessages } from "../../hooks/useAiLoadingMessages";

const useStyles = makeStyles((theme) => ({
  container: {
    position: "absolute",
    right: "calc(100% + 20px)", // Posiciona mais à esquerda do botão
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap", // Impede quebra de linha
    minWidth: "180px", // Largura mínima garantida
    maxWidth: "none", // Remove limitação de largura máxima
  },
  message: {
    fontSize: "11px",
    color: theme.palette.grey[500],
    fontStyle: "italic",
    lineHeight: 1.2,
    animation: "$fadeInOut 0.5s ease-in-out",
    whiteSpace: "nowrap", // Garante que não quebra
  },
  "@keyframes fadeInOut": {
    "0%": {
      opacity: 0,
      transform: "translateX(10px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateX(0)",
    },
  },
}));

/**
 * Componente que exibe mensagens rotativas durante o loading da IA
 * @param {boolean} isLoading - Se está carregando
 * @param {number} interval - Intervalo entre mensagens (opcional)
 */
const AiLoadingMessage = ({ isLoading, interval }) => {
  const classes = useStyles();
  const currentMessage = useAiLoadingMessages(isLoading, interval);

  if (!isLoading) {
    return null;
  }

  return (
    <Box className={classes.container}>
      <Fade in={!!currentMessage} timeout={300}>
        <Typography className={classes.message} key={currentMessage}>
          {currentMessage}
        </Typography>
      </Fade>
    </Box>
  );
};

AiLoadingMessage.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  interval: PropTypes.number,
};

AiLoadingMessage.defaultProps = {
  interval: 2500,
};

export default AiLoadingMessage;
